import { t } from "i18next";
import CheckBoxType1 from "../../components/inputs/type1/checkbox/CheckBoxType1";
import TextInputType1 from "../../components/inputs/type1/text/TextInputType1";
import CSSClassSerivce from "../../services/CommonCSSSerivce";
import ButtonType1 from "../../components/inputs/type1/ButtonType1";
import TextInputReadOnlyType1 from "../../components/inputs/type1/text/TextInputReadOnlyType1";
import TextAreaInputType1 from "../../components/inputs/type1/text/TextAreaInputType1";
import RadiosType1 from "../../components/inputs/type1/radios/RadiosType1";
import { CommonService } from "../../../../common/main/services/CommonService";
import { ReactNode } from "react";
import { IInputValidatorItem } from "../inputvalidation/interfaces/InputValidationInterfaces";
import DatePickerInput1 from "../../components/inputs/type1/datepicker/DatePickerInput1";
import SelectCustomType1 from "../../components/inputs/type1/selectcustom/SelectCustomType1";
import { EInputValidationResultType } from "../inputvalidation/enums/InputValidationEnums";
import DynamicSearchList1 from "../../components/inputs/type1/dynamicsearchlist/DynamicSearchList1";
import { IDynamicSearchListController1Return } from "../../components/inputs/type1/dynamicsearchlist/DynamicSearchListController1";
import { ELng } from "../../../../language/main/LanguageKeysEnums";
import { IGUIElementController } from "./CommonReactGUIElementsInterfaces";


//#region interfaces
export interface IGUIElementValidation {
  label?: string;
  required?: boolean;
  validationItems?: IInputValidatorItem[] | null;
}

export interface ICheckBoxProps {
  showLabel?: boolean;
  required?: boolean;
  label?: string;
  name?:string;
  id?:string;
  descNode?: ReactNode;
  ebc?: IGUIElementController;
  classNameFrame?: string;
  desc?: string;
  v?: boolean;
  f?: (it: boolean) => void;
}

export interface ITextInputProps extends IGUIElementValidation {
  ebc?: IGUIElementController;
  classNameInput?: string;
  isDisabled?: boolean;
  label?:string;
  testId?:string;
  name?:string;
  placeholder?:string;
  id?:string;
  showLabel?: boolean;
  readOnly?: boolean;
  required?: boolean;
  type?: string;
  v?: string;
  validationItems?: IInputValidatorItem[] | null;
  onInputChange?: (it: string | null) => void;
  fOnInputValidation?: (it: EInputValidationResultType) => void | null;
}

export interface ISelectInputProps {
  c?: IGUIElementController;
  readOnly?: boolean;
  required?: boolean;
  label?: string;
  name?: string;
  v: string | undefined;
  o: string[];
  listBGColor?:string;
  fgetBGColorByOption?: (it?:string) => string;
  onInit?: () => void;
  fOnInputChange: (it: string) => void;
  fOnInputValidation?: ((it: EInputValidationResultType) => void) | null;
  validationItems?: IInputValidatorItem[] | null;
}

interface IButtonSaveCancelProps {
  isDisabled: boolean;
  isSubmitting: boolean;
  onIsDisabled?: () => void;
  submitLabel?: string;
  submit: (event: React.FormEvent) => void;
  cancel: (event: React.FormEvent) => void;
}

interface IButtonProps {
  label?: string;
  isDisabled?: boolean;
  type?: TypeButton;
  testId?:string;
  classNameBaseFrame?: string;
  classNameFrame?: string;
  classNameInput?: string;
  caption: () => React.ReactNode;
  ebc?: IGUIElementController;
  f?: () => void;
  //skips _FAddGlobal-function
  skipFAddGlobal?: boolean;
}

export interface IRadioProps {
  label: string;
  required?: boolean;
  groupName?: string;
  descPrefix?: string;
  v?: string;
  o: string[];
  //caption: () => React.ReactNode;
  ebc: IGUIElementController;
  fOnInputChange: (it: string) => void;
  classNameBaseFrame?: string;
  classNameAddByOption?: (option: string) => string;
  //validation
  validationItems?: IInputValidatorItem[] | null | undefined;
  fOnInputValidation?: ((it: EInputValidationResultType) => void) | null | undefined;
}

export interface IDatePickerProps extends IGUIElementValidation {
  label?: string;
  classNameRootFrame?: string;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  value?: number; //vt.timestampNextTest
  defaultValue?: number; //props.vt.timestampNextTest
  fOnInputChange?: (it: number) => void;
  validationItems?: IInputValidatorItem[] | null | undefined;
  fOnInputValidation?: ((it: EInputValidationResultType) => void) | null | undefined;
}

export interface IDynamicSearchListProps<T> extends IGUIElementValidation {
  label?: string;
  placeholder?: string;
  isDisabled?: boolean;
  dlsc:IDynamicSearchListController1Return<T>;
  classNameAdd?: string;
  validationItems?: IInputValidatorItem[] | null | undefined;
  fOnInputChange?: ((it: string | null) => void) | null;
  fOnInputValidation?: ((it: EInputValidationResultType) => void) | null | undefined;
}
//#endregion


interface IFactoryProps {
  keyStart?: string | Nude;
  FAddGlobal?: (() => void) | undefined;
  f?: () => void
}


export default class CommonReactGUIElementsFactory {

   /** function that is run after every value assignement */
  private static _FAddGlobal: (() => void) | undefined = undefined;
  /** key-start-id for input elements */
  private _keyStart: string = "";
  public set keyStart(it: string) {
    this._keyStart = it;
  }
  public get keyStart(): string {
    return this._keyStart;
  }
    
  private static _f: CommonReactGUIElementsFactory | null = null;
  public static getFactory(props: IFactoryProps): CommonReactGUIElementsFactory {
    const keyStart = props.keyStart ? props.keyStart : ""
    this._FAddGlobal = props.FAddGlobal;
    if (this._f != null) { this._f._keyStart = props.keyStart ? props.keyStart : ""; return this._f; };
    this._f = new CommonReactGUIElementsFactory(); this._f.keyStart = keyStart; return this._f;
  }

  constructor() { }

  public getSaveCancelButtons(props: IButtonSaveCancelProps): JSX.Element {
    //set default Props
    const submitLabel = (props.submitLabel)? t(props.submitLabel):t(ELng.button_save.valueOf())



    return (
    
      <div className="flex flex-col row-span-full mt-2 mb-2">
        <div className="flex justify-center">
          <ButtonType1
            type="submit"
            disabled={props.isDisabled}
            classNameInput={CSSClassSerivce.buttonCancelClass}
            disabledAddClass={CSSClassSerivce.disabledAddClass}
            onIsDisabledClick={props.onIsDisabled}
            onClick={(e) => { props.submit(e) }}
            caption={() => { return submitLabel }}
          />

          <ButtonType1
              type="button"
              disabled={false}
              classNameInput={CSSClassSerivce.buttonSubmit}
              disabledAddClass={CSSClassSerivce.disabledAddClass}
              onClick={(e) => { 
                props.cancel(e);
              }}
              caption={() => {return t(ELng.button_cancel.valueOf())} }
            /> 
        </div>
      </div>
    )
  }


  public getDynamicSearchList<T>(props: IDynamicSearchListProps<T>): JSX.Element {
    //const fAddGlobal = GUIElementsFactory._FAddGlobal


    return (<DynamicSearchList1
      label={props.label}
      placeholder={props.placeholder}
      isDisabled={props.isDisabled}
      dlsc={props.dlsc}
      classNameAdd={props.classNameAdd}
      validationItems={props.validationItems}
      onInputValidation={(it) => props.fOnInputValidation?props.fOnInputValidation(it):{} }
      fAddGlobal={CommonReactGUIElementsFactory._FAddGlobal}
      
      //functions
      // fOnInputChange={(it) => { 
      //   try {
      //     //props.onInputChange!!(it);
      //     //function added to the GUIElementsfactory. Is called  by every elemete build wiht this factory settings
      //     fAddGlobal ? fAddGlobal() : null;
      //   } catch (e) {
      //   }
      // }}

     
    />)
  }


  public getButtonType1(props: IButtonProps): JSX.Element {
    //set default props
    (props.type == undefined)? props.type = "button": {};
    const fAddGlobal = CommonReactGUIElementsFactory._FAddGlobal

    return (
      <ButtonType1
        label={props.label}
        type={props.type}
        testId={props.testId}
        disabled={props.ebc?props.ebc.isDisabled:props.isDisabled?props.isDisabled:false}
        classNameBaseFrame={props.classNameBaseFrame}
        classNameFrame={props.classNameFrame}
        classNameInput={props.classNameInput?props.classNameInput:CSSClassSerivce.button2}
        disabledAddClass={CSSClassSerivce.disabledAddClass}
        onClick={(e) => { try{ 
          props.f?props.f():{}; 
  
          if(!props.skipFAddGlobal) {
            fAddGlobal?fAddGlobal():null 
          }
         
        } catch(e) { return null} }}
        caption={props.caption}
      /> )
  }


  public getRadios(props: IRadioProps): JSX.Element {
    (props.groupName == undefined)? props.groupName = CommonService.getRandomHash():{};
    (props.classNameBaseFrame == undefined)? props.classNameBaseFrame = CSSClassSerivce.radioClassBaseFrameRow:{};
    //(props.classNameFrame == undefined)? props.classNameFrame = CSSClassSerivce.radioClassBaseFrameRow:{};
    const fAddGlobal = CommonReactGUIElementsFactory._FAddGlobal

    return (
      <RadiosType1
        key={props.v}
        groupName={props.groupName}
        label={props.label}
        required={props.required}
        options={props.o}
        descPrefix={props.descPrefix?props.descPrefix:""}
        currentOption={props.v}
        t={t}
        c={props.ebc}
        onInputChange={(it) => { try { props.fOnInputChange(it); fAddGlobal?fAddGlobal():null } catch (e) { } } }
        //css
        classNameRootFrame={CSSClassSerivce.radioClassRootFrame}
        classNameBaseFrame={props.classNameBaseFrame}
        classNameFrame={props.classNameBaseFrame}
        classNameInput={CSSClassSerivce.radioClassInput}
        classNameDisabled={CSSClassSerivce.disabledAddClass}     
        //functions
        classNameAddByOption={props.classNameAddByOption}
        onInputValidation={(it) => props.fOnInputValidation?props.fOnInputValidation(it):{} }
        validationItems = {props.validationItems}
      />
    )
  }
  
  public getSelectInput(props: ISelectInputProps): JSX.Element {
    const fAddGlobal = CommonReactGUIElementsFactory._FAddGlobal

    return (
      <SelectCustomType1 
        label={props.label}
        name={props.name}
        readOnly={props.readOnly}
        required={props.required}
        value={props.v}
        disabled={props.c?props.c.isDisabled: false} 
        classNameInput={CSSClassSerivce.selectClass}
        disabledAddClass={CSSClassSerivce.disabledAddClass} 
        listBGColor={props.listBGColor}
        options={props.o} 
        onInit = {props.onInit}
        onInputChange={(it) => { try { props.fOnInputChange(it); fAddGlobal?fAddGlobal():null  } catch (e) {} }} 
        onInputValidation={(it) => props.fOnInputValidation?props.fOnInputValidation(it):{} }
        validationItems={props.validationItems}
        getColorByOption= {props.fgetBGColorByOption}
      />
    )
  }

  public getDatePicker(props: IDatePickerProps): JSX.Element {

    const fAddGlobal = CommonReactGUIElementsFactory._FAddGlobal

    return <DatePickerInput1
      name={props.label}
      disabled={props.isDisabled}
      classNameRootFrame={props.classNameRootFrame?props.classNameRootFrame:""}
      classNameFrame={CSSClassSerivce.datePickerFrame}
      classNameInput={CSSClassSerivce.datePickerInput}
      //timeStamp={props.vt.timestampNextTest}
      timeStamp={props.value}
      //defaultValue={props.vt.timestampNextTest}
      defaultValue={props.defaultValue}

      disabledAddClass={CSSClassSerivce.disabledAddClass}

      //dateMin={props.service.getNextTestDateMin()}
      //dateMax={props.service.getNextTestDateMax()}
      onInputChange={(it) => { 
        try {
          //props.vt.timestampNextTest = it!! 
          //props.vtec.handleDirytDataEvent();
          props.fOnInputChange!!(it!!);
          //function added to the GUIElementsfactory. Is called  by every elemete build wiht this factory settings
          fAddGlobal ? fAddGlobal() : null;
        } catch (e) { } 
      }}
      onInputValidation={(it) => props.fOnInputValidation?props.fOnInputValidation(it):{} }
      validationItems = {props.validationItems}
    />
  }

  //#region text
  public getTextAreaInput(props: ITextInputProps): JSX.Element {

    //set default values
    (props.readOnly == undefined ? props.readOnly = false : {});
    (props.showLabel == undefined ? props.showLabel = false : {});
    (props.onInputChange == undefined ? props.onInputChange = (it: string | null) => { } : {});
    (props.type == undefined)? props.type = "text": {};
    (props.classNameInput == undefined)?props.classNameInput=CSSClassSerivce.textAreaInputClass: null

    const fAddGlobal = CommonReactGUIElementsFactory._FAddGlobal;
    
    return (
      <TextAreaInputType1
        id={props.id}
        testId = {props.testId}
        name={(props.showLabel == true) ? props.label : undefined}
        required={props.required}
        readOnly={props.readOnly}
        disabled={props.ebc?props.ebc.isDisabled:props.isDisabled?props.isDisabled:false} 
        defaultValue={props.v}
        placeholder={props.placeholder}
        classNameRoot={CSSClassSerivce.textAreaRootClass}
        classNameInput={props.classNameInput}
        disabledAddClass={CSSClassSerivce.disabledAddClass}
        validationItems={props.validationItems}
        onInputValidation={(it) => props.fOnInputValidation?props.fOnInputValidation(it):{} }
        onInputChange={(it) => { try { props.onInputChange!!(it); fAddGlobal ? fAddGlobal() : null } catch (e) { } } }
      />
    )
  }


  public getTextInput(props: ITextInputProps): JSX.Element {

    //set default values
    (props.readOnly == undefined)? props.readOnly = false:{};
    (props.onInputChange == undefined)? props.onInputChange = (it: string | null) => {}:{};

    (props.type == undefined)? props.type = "text":{};

    const fAddGlobal = CommonReactGUIElementsFactory._FAddGlobal

    return (
      (props.readOnly == false)?(
        <TextInputType1
          //readOnly={props.readOnly}
          testId = {props.testId}
          id={props.id}
          keyStart={this.keyStart}
          type={props.type}
          label={props.label}
          placeholder={props.placeholder}
          name={props.name}
          required={props.required}
          disabled={props.ebc?props.ebc.isDisabled:props.isDisabled?props.isDisabled:false} 
          defaultValue={props.v}
          classNameInput={CSSClassSerivce.textInputClass}
          disabledAddClass={CSSClassSerivce.disabledAddClass}
          validationItems = {props.validationItems}
          //functions
          onInputValidation={(it) => props.fOnInputValidation?props.fOnInputValidation(it):{} }
          onInputChange={(it) => { 
            try {
              props.onInputChange!!(it);
              //function added to the GUIElementsfactory. Is called  by every elemete build wiht this factory settings
              fAddGlobal ? fAddGlobal() : null;
            } catch (e) {
            }
          }}
        />
      ):(<>
        <TextInputReadOnlyType1 
          readOnly={props.readOnly}
          testId = {props.testId}
          //keyStart={GUIElementsFactory._keyStart}
          //keyStart={props.keyStart}
          placeholder={props.placeholder}
          name={props.label}
          disabled={true} 
          defaultValue={props.v} 
          classNameInput={CSSClassSerivce.textInputClass} 
          disabledAddClass={CSSClassSerivce.disabledAddClass} 
          onInputChange={(it) => { try { props.onInputChange!!(it); fAddGlobal?fAddGlobal():null } catch(e) {} }}
        />
        </>)
    )
  }
  //#endregion


  public getCheckBox(props: ICheckBoxProps): JSX.Element {
    //set default values
    (props.showLabel == undefined) ? props.showLabel = false : undefined;
    const fAddGlobal = CommonReactGUIElementsFactory._FAddGlobal

    return (
      <CheckBoxType1
        label={props.showLabel == true ? props.label : undefined}
        name={props.name}
        id={props.id}
        descNode={props.descNode}
        desc={props.desc}
        classNameFrame={ props.classNameFrame ? props.classNameFrame : CSSClassSerivce.checkBoxClassFrame }
        classNameInput={CSSClassSerivce.checkBoxClass}
        disabledAddClass={CSSClassSerivce.disabledAddClass}
        disabled={props.ebc?props.ebc.isDisabled:false}
        value={props.v != undefined ? props.v : false}
        onInputChange={(it: boolean) => { try { 
          props.f?props.f(it):{}; 
          fAddGlobal?fAddGlobal():null 
        } catch (e) {} }}
      />
    );
  }
}
